import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { topStoriesItemContent$key } from "~/queries/__generated__/topStoriesItemContent.graphql";

import { Container, StyledContentItemRender } from "./styles";

export type Props = {
  className?: string;
  isShowImage?: boolean;
  onClick: (entityId?: string) => void;
  reference: topStoriesItemContent$key;
  variant: "primary" | "secondary";
};

export const TopStoriesItem: FunctionComponent<Props> = ({
  className,
  isShowImage = false,
  onClick,
  reference,
  variant,
}) => {
  const content = useFragment(
    graphql`
      fragment topStoriesItemContent on Content {
        ...contentItemRenderContent
      }
    `,
    reference,
  );

  const renderItem = () => {
    switch (variant) {
      case "primary":
        return (
          <StyledContentItemRender
            reference={content}
            variant="home-primary"
            withComment
            withLiveTag
            onClick={entityId => {
              onClick(entityId);
            }}
          />
        );
      case "secondary":
        return (
          <StyledContentItemRender
            reference={content}
            variant="home-secondary"
            withImage={isShowImage}
            withComment
            withLiveTag
            withSection
            withSummary
            onClick={entityId => {
              onClick(entityId);
            }}
          />
        );
    }
  };

  return <Container className={className}>{renderItem()}</Container>;
};

TopStoriesItem.displayName = "TopStoriesItem";
